import type { UI } from '@/v2/types';
import React from 'react';
import { Text } from '@qga/roo-ui/components';

import useToggle from '@shared/v2/hooks/useToggle';
import { PackageOption as PackageOptionType } from '@shared/v2/utils/getPackageOptions';

import LinkButton from '@/components/LinkButton/LinkButton';
import RoomOptionDetails from '@/v2/components/pages/PackageView/components/RoomOptionDetails';
import Modal from '@/v2/components/ui/Modal';

export type PackageDetailsProps = {
  packageOption?: PackageOptionType;
  roomOption?: UI.RoomOption;
};

const PackageDetails = ({ packageOption, roomOption }: PackageDetailsProps) => {
  // Modal State
  const { value: isOpen, setOn: openModal, setOff: closeModal } = useToggle();

  // Package Data
  const { matchingOffer, roomType } = roomOption || {};
  const { title } = packageOption ?? {};

  return (
    <>
      {/*@ts-ignore - doesn't like children for some reason*/}
      <LinkButton onClick={openModal}>
        <Text textDecoration="underline" fontSize="sm" color="brand.primary">
          View package details
        </Text>
      </LinkButton>
      {isOpen && (
        <Modal onClose={closeModal}>
          <Modal.Header>Package details</Modal.Header>
          {matchingOffer && roomType && (
            <Modal.Body p="5">
              <RoomOptionDetails
                roomName={roomType.name}
                offer={matchingOffer}
                packageName={title}
              />
            </Modal.Body>
          )}
        </Modal>
      )}
    </>
  );
};

export default PackageDetails;
